import { Component, Input, EventEmitter, Output } from '@angular/core';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';

import { TableComponent } from '../../table.component';
import { param } from '../../../http-params';
import {
    SystemMessage,
    SystemMessageService,
} from 'app/core/system-message/system-message-service';

@Component({
    selector: 'pcg-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
    standalone: false,
})
export class DeleteButtonComponent<T> {
    @Input() url: string;
    @Input() id: string;
    @Input() confirmMessage = 'Are you sure you want to delete this?';
    @Input() table: TableComponent<T>;
    @Output() delete = new EventEmitter<SystemMessage>();

    faIconName = { faTrashCan };

    constructor(private ms: SystemMessageService) {}

    deleteRecord() {
        if (confirm(this.confirmMessage)) {
            const idQueryStr =
                typeof this.id === 'string' || typeof this.id === 'number'
                    ? 'id=' + encodeURIComponent(this.id)
                    : param(this.id);
            this.ms
                .getHttpObservable(this, this.url + '?' + idQueryStr)
                .subscribe((systemMessage: SystemMessage) => {
                    this.delete.emit(systemMessage);
                    if (this.table) {
                        this.table.ajaxReload();
                    }
                });
        }
    }
}
